/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    em: "em",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "Timeline"
      }), " properties"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "data"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " List of ", _jsx(_components.a, {
              href: "/uilib/components/timeline/properties#timelineitem-properties",
              children: "timeline items"
            }), " to render. Each object in data can include all properties from ", _jsx(_components.a, {
              href: "/uilib/components/timeline/properties#timelineitem-properties",
              children: "Timeline.Item properties"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "children"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Content of the component. Can be used instead of property ", _jsx(_components.code, {
              children: "data"
            }), ", by adding ", _jsx(_components.a, {
              href: "/uilib/components/timeline/properties#timelineitem-properties",
              children: "Timeline Item"
            }), " as children ", _jsx(_components.code, {
              children: "<Timeline.Item {...props} />"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Applies loading skeleton."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "className"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Custom className for the component root."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "Timeline.Item"
      }), " properties"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " Title of the Timeline item."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " The component state. Options: ", _jsx(_components.code, {
              children: "completed"
            }), " | ", _jsx(_components.code, {
              children: "current"
            }), " | ", _jsx(_components.code, {
              children: "upcoming"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "subtitle"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Subtitle of the Timeline item, displayed below the ", _jsx(_components.code, {
              children: "title"
            }), ". Also supports passing an array of subtitles. The subtitle is usually a date of the timeline item."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "infoMessage"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Info message, displayed in a ", _jsx(_components.a, {
              href: "/uilib/components/form-status#formstatus-displaying-info-status",
              children: "FormStatus of state info"
            }), ", below the ", _jsx(_components.code, {
              children: "subtitle"
            }), " if it exists."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Override icon displaying on the left side (Not recommended). Default: ", _jsx(_components.code, {
              children: "check"
            }), " for state ", _jsx(_components.code, {
              children: "completed"
            }), ", ", _jsx(_components.code, {
              children: "pin"
            }), " for state ", _jsx(_components.code, {
              children: "current"
            }), ", and ", _jsx(_components.code, {
              children: "calendar"
            }), " for state ", _jsx(_components.code, {
              children: "upcoming"
            }), " ."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "iconAlt"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Alt label describing the icon provided."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Applies loading skeleton."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
